import React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
  selected?: boolean;
  as?: 'div' | 'button';
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ interactive, selected, as = 'div', className, children, ...rest }, ref) => {
    const Element = as as 'div';
    return (
      <Element
        ref={ref as React.Ref<HTMLDivElement>}
        className={[
          'rr-card',
          interactive ? 'rr-card-interactive' : '',
          selected ? 'rr-card-selected' : '',
          className,
        ]
          .filter(Boolean)
          .join(' ')}
        {...rest}
      >
        {children}
      </Element>
    );
  }
);

Card.displayName = 'Card';

export default Card;
